import { Button, Form, FormInstance, Input, Row, Col } from 'antd'
import React, { FC } from 'react'
import styled from '@emotion/styled'
import FactoryAddress from 'components/Profiles/SettingFactory/FactoryAddress'
import { AddressFacData } from 'services/interface.d'

interface ManageMerchantFormProps {
  form: FormInstance
  onFinish: (values: any) => void
  address_fac: AddressFacData | undefined
  isPending?: boolean
  isChanged: boolean
  onValuesChange: () => void
  /** 2026-09-14: ตอนมี merchant (Speed หรือไปรษณีย์ไทย) อยู่แล้ว — ล็อกฟอร์มทั้งหมด ห้ามแก้ไขเอง
   * ต้องให้เจ้าหน้าที่แก้ให้แทน (ดูข้อความแจ้งเตือนที่ ManageMerchant/index.tsx) */
  disabled?: boolean
}

const ManageMerchantForm: FC<ManageMerchantFormProps> = ({
  form,
  onFinish,
  address_fac,
  isPending,
  isChanged,
  onValuesChange,
  disabled,
}) => {
  return (
    <Form
      form={form}
      onFinish={onFinish}
      onValuesChange={onValuesChange}
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 24 }}
      layout="vertical"
      disabled={disabled}
    >
      {/* 2026-09-14: ชื่อจุดรับสินค้าไม่ให้ผู้ใช้กรอกเอง — ซ่อนไว้เสมอ ส่งค่าคงที่ "maindc" ทุกครั้ง
       * (hidden ยังคงอยู่ใน form values ให้ onFinish ส่งไปด้วย ต่างจากการลบ field ทิ้งไปเลย) */}
      <Form.Item name="pickup_name" initialValue="maindc" hidden>
        <Input />
      </Form.Item>

      {/* ที่อยู่ + จังหวัด/อำเภอ/ตำบล/ไปรษณีย์ — ใช้ Component เดิม */}
      <FactoryAddress form={form} address_fac={address_fac} />

      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Form.Item
            name="mobile"
            label="เบอร์โทรศัพท์"
            rules={[{ required: true, message: 'กรุณากรอกเบอร์โทรศัพท์' }]}
          >
            <Input placeholder="0812345678" maxLength={20} />
          </Form.Item>
        </Col>

        <Col xs={24} md={12}>
          <Form.Item
            name="email"
            label="อีเมล"
            rules={[
              { required: true, message: 'กรุณากรอกอีเมล' },
              { type: 'email', message: 'รูปแบบอีเมลไม่ถูกต้อง' },
            ]}
          >
            <Input placeholder="example@email.com" maxLength={100} />
          </Form.Item>
        </Col>
      </Row>

      {!disabled && (
        <Form.Item>
          <WrapperButton>
            <Button
              style={{ width: 250 }}
              type="primary"
              size="large"
              htmlType="submit"
              loading={isPending}
              disabled={!isChanged}
            >
              บันทึก
            </Button>
          </WrapperButton>
        </Form.Item>
      )}
    </Form>
  )
}

export default ManageMerchantForm

const WrapperButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
`
